import size from "../sizes";
import sublimationPrinting from "./templates/sublimation-printing";

export default [
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `<p>Майка-борцовка является уникальным дизайнерским решением, которое отлично подчеркнет фигуру. В ней удобны и прогулки и занятия спортом. Запечатывается вся поверхность майки-борцовки с обеих сторон. Картинка получается яркой и долговечной.</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${sublimationPrinting}`
    }
  },
  {
    id: `size`,
    title: `Размерная сетка`,
    content: {
      table: size[`full_print_tanktop`],
      sizeInfo: `full_print_tanktop`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
